adminApp.component('popAllocatedIps', {
	templateUrl: '/public/components/adminGui/pop-allocated-ips.component.html',
	controller: popAllocatedIpsController,
});

function popAllocatedIpsController($scope, $state, LocationService, SystemAllocatedIpsService, GeneralUtilsService, IconsService) {
	var ctrl = this;

	ctrl.$onInit = function () {
		ctrl.hasChanges = false;
		loadLocations();
	};
	ctrl.allocatedIps = [];

	ctrl.datamodified = new Date().getTime();

	ctrl.setAllocatedIpsDisplay = function (serverResponse) {
		if (serverResponse.status !== 'ERROR') {
			$scope.$root.handleServerResponse(serverResponse, '', 'Changes saved successfully');
			ctrl.tableConfig.items = ctrl.setDisplayValues(serverResponse.data.ips);
		} else {
			$scope.$root.handleServerResponse(serverResponse, '', '');
		}
	};

	ctrl.setDisplayValues = function (ips) {
		ctrl.allocatedIps = ips;
		ctrl.originalAllocatedIps = angular.copy(ctrl.allocatedIps);
		ctrl.deletedIpIds = [];
		ctrl.newIps = [];
		ctrl.hasErros = false;
		ctrl.loading = false;
		return ctrl.allocatedIps;
	};

	ctrl.$doCheck = function () {
		ctrl.hasChanges = !angular.equals(ctrl.originalAllocatedIps, ctrl.allocatedIps) && !ctrl.tableConfig.items.some(item => item.error);
	};

	ctrl.stopLoad = function () {
		$scope.$broadcast('stop-load');
	};

	ctrl.saveChanges = function () {
		const maxItemsPerDelete = 10;
		ctrl.changesToSave = { newIps: ctrl.newIps, deletedIpIds: ctrl.deletedIpIds.map(i => i.id) };
		const itemsLen = ctrl.deletedIpIds.length;
		if (itemsLen > maxItemsPerDelete) {
			ctrl.stopLoad();
			$scope.$root.alert(`${itemsLen} items selected. Please select up to ${maxItemsPerDelete} items.`);
			return;
		}
		const itemsToDelete = ctrl.deletedIpIds.map(i => i.ip);
		const itemsMessage = itemsLen === 1 ? `one item - ${itemsToDelete}` : itemsLen + ` items - ${itemsToDelete}`;
		const confirmMessage = 'Are you sure you want to remove ' + itemsMessage + '?';
		$scope.$root.confirm(confirmMessage, function () {
			SystemAllocatedIpsService.saveSystemAllocatedIpsChanges(ctrl.changesToSave, ctrl.setAllocatedIpsDisplay);
		});
		ctrl.stopLoad();
	};

	function loadLocations() {
		LocationService.getPopLocations(1, updateLocations);
		LocationService.getPopMachines(1, updateMachines);
	}

	function updateLocations(data) {
		ctrl.tableConfig.locations = data;
	}

	function updateMachines(data) {
		const map = new Map();
		data.forEach((item) => {
			const key = item.locationId;
			const collection = map.get(key);
			if (!collection) {
				map.set(key, [item]);
			} else {
				collection.push(item);
			}
		});
		ctrl.tableConfig.machines = map;
	}

	ctrl.egressChange = function (index, location, machine) {
		let fetchingIp = true;
		var allAllocatedIps = {};

		// send request to the server to assign new IP
		store.fetch({
			data: allAllocatedIps,
			method: 'GET',
			dataObj: 'currentIpsStr',
			path: 'ag/getNewIPFromMachine?location=' + location + '&machine=' + machine,
			// queryParams: {'location': $scope.allocatedIps[index].locationId},
			success: function (data) {
				if (data == null) {
					ctrl.tableConfig.items[index].ip = 'Not enough free IP addresses in machine ' + ctrl.tableConfig.machines.get(ctrl.tableConfig.items[index].locationId).find(a => a.id === ctrl.tableConfig.items[index].popId).name;
					ctrl.tableConfig.items[index].error = true;
				} else {
					delete ctrl.tableConfig.items[index].error;
					/*
                     *  if no id is set on the egress meaning new we assign an id for the
                     *  difference between the objects
                     */
					if (!ctrl.tableConfig.items[index].id) ctrl.tableConfig.items[index].id = GeneralUtilsService.getRandomId();
					ctrl.tableConfig.items[index].ip = data.ip;
					if (!ctrl.newIps.includes(ctrl.tableConfig.items[index])) ctrl.newIps.push(ctrl.tableConfig.items[index]);
				}
				fetchingIp = false;
			},
		});
	};

	ctrl.tableConfig = {
		searchId: $state.params.ruleId,
		type: 'SYSTEMALLOCATEDIP',
		dataURL: function () {
			return '/getSystemAllocatedIps';
		},
		parseData: function (serverResponse) {
			if (serverResponse.status !== 'ERROR') {
				return ctrl.setDisplayValues(serverResponse.data.ips);
			}
			$scope.$root.handleServerResponse(serverResponse, '', '');
		},
		titleSearch: 'System Allocated IPs',
		clientSideSearch: true,
		searchField: 'description',
		noSearch: true,
		noDataMessage: ' ',
		specialActions: [
			{
				icon: 'simple-plus',
				text: 'ADD IP',
				tooltip: 'Add',
				id: 'add-system-allocated-ip',
				func: function (selectedItems, tableConfig, $event) {
					const allocatedIp = {
						id: GeneralUtilsService.getRandomId(), name: 'AllocatedIP', isSystemAllocated: true, ipAllocationType: 'CLOUD_ACCESS',
					};
					tableConfig.items.push(allocatedIp);
					ctrl.newIps.push(allocatedIp);
				},
			},
		],
		fixedLayout: true,
		egressChange: ctrl.egressChange,
		fields: [
			{ label: 'Internal ID', path: '{{item.id}}', template: "<div style='width: 80px'>{{item.id > 0 ? item.id : 'New'}}</div>" },
			{ label: 'Location Name', path: '{{item.id}}.locationId', template: '<select style=\'width: 150px\' ng-model="item.locationId" ng-options="location.id as location.name for location in tableConfig.locations"></select>' },
			{ label: 'Machine Name', path: '{{item.id}}.locationId', template: '<select style=\'width: 150px\' ng-model="item.popId" ng-options="machine.id as machine.name for machine in tableConfig.machines.get(item.locationId)" ng-disabled="!item.locationId" ng-change="tableConfig.egressChange(tableConfig.items.indexOf(item), item.locationId, item.popId)"></select>' },
			{ label: 'IP', path: '{{item.id}}.ip', template: "<div style='width: 200px'>{{item.ip}}</div>" },
			{
				label: 'Remove',
				path: '{{item.id}}',
				template: "<div style='width: 60px' ng-click='tableConfig.deleteRule(item, $event)'>"
    + "<svg class='icon icon-delete cato-tooltip system-allocated-ip-bin' data-title='Delete'><use xlink:href='' ng-href='/public/images/icons/main.svg#icon-delete'></use></svg>"
    + '</div>',
			},

		],
		extraFieldsToSearch: [{ path: 'ip' }],
		defer: true,
		sortList: [{ sortField: 'id', sortDir: 'ASC' }],
		pageSize: 999,
		hideCheckboxes: true,
		noAutoSelect: true,
		nameField: 'description',
		items: [],
		deleteRule: function (item, $event) {
			const itemIndexToRemove = ctrl.tableConfig.items.indexOf(item);
			ctrl.tableConfig.items.splice(itemIndexToRemove, 1);
			ctrl.newIps = ctrl.newIps.filter(allocatedIp => allocatedIp.id !== item.id);
			if (item.id > 0) {
				ctrl.deletedIpIds.push(item);
			}
		},
	};
}
